import { Center, Container } from '@mantine/core';
import React from 'react';

import { PrivacyChoices } from '@/components/PrivacyChoices';

const PrivateLayoutFooter = () => (
  <Container>
    <Center>
      <PrivacyChoices />
    </Center>
  </Container>
);

export default PrivateLayoutFooter;
